export const indigo = {
  1: { value: { base: '{colors.indigo.light.1}', _dark: '{colors.indigo.dark.1}' } },
  2: { value: { base: '{colors.indigo.light.2}', _dark: '{colors.indigo.dark.2}' } },
  3: { value: { base: '{colors.indigo.light.3}', _dark: '{colors.indigo.dark.3}' } },
  4: { value: { base: '{colors.indigo.light.4}', _dark: '{colors.indigo.dark.4}' } },
  5: { value: { base: '{colors.indigo.light.5}', _dark: '{colors.indigo.dark.5}' } },
  6: { value: { base: '{colors.indigo.light.6}', _dark: '{colors.indigo.dark.6}' } },
  7: { value: { base: '{colors.indigo.light.7}', _dark: '{colors.indigo.dark.7}' } },
  8: { value: { base: '{colors.indigo.light.8}', _dark: '{colors.indigo.dark.8}' } },
  9: { value: { base: '{colors.indigo.light.9}', _dark: '{colors.indigo.dark.9}' } },
  10: { value: { base: '{colors.indigo.light.10}', _dark: '{colors.indigo.dark.10}' } },
  11: { value: { base: '{colors.indigo.light.11}', _dark: '{colors.indigo.dark.11}' } },
  12: { value: { base: '{colors.indigo.light.12}', _dark: '{colors.indigo.dark.12}' } },
  a1: { value: { base: '{colors.indigo.light.a1}', _dark: '{colors.indigo.dark.a1}' } },
  a2: { value: { base: '{colors.indigo.light.a2}', _dark: '{colors.indigo.dark.a2}' } },
  a3: { value: { base: '{colors.indigo.light.a3}', _dark: '{colors.indigo.dark.a3}' } },
  a4: { value: { base: '{colors.indigo.light.a4}', _dark: '{colors.indigo.dark.a4}' } },
  a5: { value: { base: '{colors.indigo.light.a5}', _dark: '{colors.indigo.dark.a5}' } },
  a6: { value: { base: '{colors.indigo.light.a6}', _dark: '{colors.indigo.dark.a6}' } },
  a7: { value: { base: '{colors.indigo.light.a7}', _dark: '{colors.indigo.dark.a7}' } },
  a8: { value: { base: '{colors.indigo.light.a8}', _dark: '{colors.indigo.dark.a8}' } },
  a9: { value: { base: '{colors.indigo.light.a9}', _dark: '{colors.indigo.dark.a9}' } },
  a10: { value: { base: '{colors.indigo.light.a10}', _dark: '{colors.indigo.dark.a10}' } },
  a11: { value: { base: '{colors.indigo.light.a11}', _dark: '{colors.indigo.dark.a11}' } },
  a12: { value: { base: '{colors.indigo.light.a12}', _dark: '{colors.indigo.dark.a12}' } },
}
